import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { computed } from 'vue'
import { detectSocialMedia } from '@lukso/web-components/tools'

import { LinkMetadataSocialMedia } from '@/shared/models/Profile'

import type { LinkMetadata } from '@lukso/lsp-smart-contracts'

type Props = {
  links?: LinkMetadata[]
}

type Slots = {
  default(props: {
    hasLinks: boolean
    socialMediaLinks: LinkMetadataSocialMedia[]
    otherLinks: LinkMetadataSocialMedia[]
    linksParsed: LinkMetadataSocialMedia[]
  }): any
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileLinks',
  props: {
    links: {}
  },
  setup(__props: any) {

const props = __props


const linksParsed = computed(
  () =>
    props?.links
      ?.filter(link => link.url)
      ?.map(
        link =>
          ({
            ...link,
            socialMediaName: detectSocialMedia(link?.url),
          }) as LinkMetadataSocialMedia
      ) || []
)

const hasLinks = computed(() => !!linksParsed.value?.length)

const socialMediaLinks = computed(
  () => linksParsed.value?.filter(link => !!link.socialMediaName)
)
const otherLinks = computed(
  () => linksParsed.value?.filter(link => !link.socialMediaName)
)

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default", {
    hasLinks: hasLinks.value,
    socialMediaLinks: socialMediaLinks.value,
    otherLinks: otherLinks.value,
    linksParsed: linksParsed.value
  })
}
}

})